export default {
    quadrant: {
        summary: {
            allZero: 'sve vrijednosti: 0.000',
            allActive: 'svih {count} aktivno',
            someActive: '{active} od {total} intervala aktivno',
        },
    },
}
